<template>
  <div class="orderDetails-view">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/personal/myorder/allOrder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="consignee" v-show="msg.bookType === 0">
      <p>收货人信息</p>
      <p>{{ '收货人：' + msg.consignee }}</p>
      <p>{{ '收货人电话：' + msg.tel }}</p>
      <p>{{ '收货人地址：' + msg.address }}</p>
    </div>
    <div class="list">
      <p>送货清单</p>
      <el-table
        ref="multipleTable1"
        :data="paperbookData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          label="商品信息"
          align="left">
          <template slot-scope="scope">
            <div class="goods-view">
              <div class="left">
                <img :src="scope.row.coverUrl" alt="">
              </div>
              <div class="right">
                <p class="p-describe">
                  {{scope.row.bookAuthors}}
                </p>
                <p class="p-author">
                  {{scope.row.bookName}}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="money"
          label="单价（元）"
          align="center"
          width="300">
          <template slot-scope="scope">
            <span>
              ￥{{scope.row.price}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          align="center"
          width="300">
          <template slot-scope="scope">
            <span>
              {{scope.row.num}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="money"
          label="总价（元）"
          align="center"
          width="150">
          <template slot-scope="scope">
            <span class="rowMoney">
              ￥{{scope.row.totalPrice}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    return {
      dialogFormVisible: false,
      addressTitle: '',
      paperbookData: [],
      multipleSelection1: [],
      allQuery: {},
      formLabelWidth: '120px',
      consigneeList: [],
      options: [],
      msg: {}
    }
  },
  methods: {
  },
  mounted () {
    let query = this.$route.query
    if (query) {
      this.paperbookData = JSON.parse(query.list)
      this.msg = query
    }
  }
}
</script>
<style lang="less" scoped>
  .orderDetails-view{
    padding: 30px 10px 0 10px;
    .consignee{
      margin-top: 30px;
      ul{
        list-style: none;
        padding: 0;
        margin: 0;
        li{
          margin-bottom: 20px;
          .item-d{
            p{
              padding: 5px 0;
              margin: 0;
            }
            border: 1px solid #666666;
            cursor: pointer;
            display: inline-block;
            padding: 0 10px;
          }
          .active{
            border: 1px solid red;
          }
        }
      }
    }
    .list{
      .goods-view{
        display: flex;
        .left{
          img{
            width: 60px;
            height: 80px;
          }
        }
        .right{
          flex: 1;
          padding-left: 30px;
          p{
            padding: 0;
            margin: 0;
          }
          .p-describe{
            color: #000000;
            overflow: hidden;
            word-break: break-all;
            display: -moz-box;
            -moz-box-orient:vertical;
            display: -webkit-box;
            -webkit-box-orient:vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
          }
          .p-author{
            margin-top: 10px;
            color: #666666;
            overflow: hidden;
            word-break: break-all;
            display: -moz-box;
            -moz-box-orient:vertical;
            display: -webkit-box;
            -webkit-box-orient:vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
          }
        }
      }
      .number-view{
        text-align: center;
        span{
          display: inline-block;
          line-height: 30px;
          text-align: center;
          vertical-align: middle;
        }
        .reduce, .plus{
          background: #DCDCDC;
          cursor: pointer;
          font-size: 20px;
          font-weight: 600;
          outline: none;
          border: 0;
          line-height: 30px;
          padding: 0;
          margin: 0;
          vertical-align: middle;
        }
        .num{
          height: 28px;
          padding: 0 10px;
          background: white;
          border: 1px solid #DCDCDC;
          margin: 0 -4px 0 -4px;
        }
      }
      .cz{
        span{
          cursor: pointer;
        }
      }
      .rowMoney{
        font-size: 16px;
        color: red;
      }
    }
  }
  .js{
    text-align: right;
    padding: 30px 50px;
    button{
      height: 40px;
      width: 100px;
      color: white;
      background: #B7151E;
      border: 0;
      border-radius: 6px;
      font-size: 18px;
      outline: none;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderDetails/orderDetails1.vue